/* Case Studies listing — client-side filter / search / sort + view toggle */
(function () {
  function init(root) {
    if (!root || root.dataset.cslInit === '1') return;
    root.dataset.cslInit = '1';

    var grid = root.querySelector('[data-csl-grid]');
    var cards = grid ? Array.from(grid.querySelectorAll('[data-csl-card]')) : [];
    var tabs = Array.from(root.querySelectorAll('[data-csl-tab]'));
    var searchInput = root.querySelector('[data-csl-search]');
    var searchClear = root.querySelector('[data-csl-search-clear]');
    var sortSel = root.querySelector('[data-csl-sort]');
    var viewBtns = Array.from(root.querySelectorAll('[data-csl-view]'));
    var countEl = root.querySelector('[data-csl-count]');
    var titleEl = root.querySelector('[data-csl-results-title]');
    var titleBase = titleEl ? titleEl.dataset.csl_base || titleEl.textContent.trim() : '';
    var empty = root.querySelector('[data-csl-empty]');

    var state = {
      filter: 'All',
      query: '',
      sort: 'latest',
      view: grid ? (grid.getAttribute('data-view') || 'image') : 'image',
    };

    function recomputeCounts() {
      var counts = { All: cards.length };
      cards.forEach(function (c) {
        var ind = c.dataset.industry || '';
        counts[ind] = (counts[ind] || 0) + 1;
      });
      tabs.forEach(function (t) {
        var key = t.dataset.cslTab;
        var c = counts[key] || 0;
        var countSpan = t.querySelector('.csl-tab__count');
        if (countSpan) countSpan.textContent = c;
      });
    }

    function matches(card) {
      if (state.filter !== 'All' && card.dataset.industry !== state.filter) return false;
      if (state.query) {
        var q = state.query.toLowerCase();
        var hay = (card.dataset.search || '').toLowerCase();
        if (hay.indexOf(q) === -1) return false;
      }
      return true;
    }

    function apply() {
      var sorted = cards.slice();
      if (state.sort === 'product') {
        sorted.sort(function (a, b) { return (a.dataset.product || '').localeCompare(b.dataset.product || ''); });
      } else if (state.sort === 'commodity') {
        sorted.sort(function (a, b) { return (a.dataset.commodity || '').localeCompare(b.dataset.commodity || ''); });
      } else {
        sorted.sort(function (a, b) {
          var ad = parseInt(a.dataset.published || '0', 10);
          var bd = parseInt(b.dataset.published || '0', 10);
          return bd - ad;
        });
      }
      var visible = 0;
      sorted.forEach(function (card) {
        var show = matches(card);
        card.classList.toggle('is-hidden', !show);
        if (show) {
          grid.appendChild(card);
          visible++;
        }
      });
      if (countEl) countEl.textContent = visible;
      if (titleEl) {
        titleEl.dataset.csl_base = titleBase;
        titleEl.firstChild && (titleEl.firstChild.nodeValue =
          state.filter === 'All' ? titleBase : (state.filter + ' operations'));
      }
      if (empty) empty.hidden = visible > 0;
      if (searchClear) searchClear.hidden = !state.query;
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        state.filter = t.dataset.cslTab;
        tabs.forEach(function (other) { other.classList.toggle('is-active', other === t); });
        apply();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        state.query = searchInput.value.trim();
        apply();
      });
    }
    if (searchClear) {
      searchClear.addEventListener('click', function () {
        if (searchInput) { searchInput.value = ''; searchInput.focus(); }
        state.query = '';
        apply();
      });
    }
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        state.sort = sortSel.value;
        apply();
      });
    }

    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.dataset.cslView;
        state.view = v;
        if (grid) grid.setAttribute('data-view', v);
        viewBtns.forEach(function (other) { other.setAttribute('aria-pressed', other === btn ? 'true' : 'false'); });
      });
    });

    recomputeCounts();
    apply();
  }

  function bootstrap() {
    document.querySelectorAll('[data-csl-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  document.addEventListener('shopify:section:load', bootstrap);
})();
